import React, { useEffect } from 'react'
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import * as actions from '../action';
import * as c from '../constant';

const CMS_TYPE = 'LOGOS'


const fields = ['MAIN_LOGO', 'SECONDARY_LOGO', 'SIMPLE_LOGO', 'LOGO', 'CORE_LOGO', 'CORE_LOGO_WHITE', 'FAVICON', 'PAYMENTS', 'FOOTER_LOGO', 'FOOTER_LOGO_CORE']

function Icons({ getList, createUploader, item, setFormData, createHidden, create, update, formData }) {
  
  useEffect(() => {
    getList({ type: CMS_TYPE })
  }, []) 

  useEffect(() => {
    
    setFormData({
      ...JSON.parse(_.get(item, 'attributes.body') || '{}'),
      id: _.get(item, 'id')
    })
  }, [item])

  const handleOnSubmit = e => {
    e.preventDefault()

    if(_.get(formData, 'id')){
      return update(
        _.get(formData, 'id'),
        {
        type: CMS_TYPE,
        body: JSON.stringify(_.pick(formData, fields))
      })
    }

    return create({
      type: CMS_TYPE,
      body: JSON.stringify(_.pick(formData, fields))
    })
  }

  return (
    <div>
      <form onSubmit={handleOnSubmit}>
        {createHidden(
          { key: 'id' },
          { placeholder: '' }
        )}
        <div className="row">
          {fields.map(field => {
            return (
              <div className="col-3 form-group d-flex flex-column justify-content-center align-items-center border p-1 rounded">
                <p>{field}</p>
                {_.get(formData, `${field}.cdnUrl`) && 
                  <img className="img-fluid" style={{ width: 150, height: 150 }} alt="Icon" src={_.get(formData, `${field}.cdnUrl`)} />
                }
                {!_.get(formData, `${field}.cdnUrl`) && 
                  <p className="text-info" style={{ height: 150 }}>SELECT IMAGE</p>
                }
                {createUploader(
                  { key: field, label: field },
                  { required: true, placeholder: '' }
                )}
              </div>
            )
          })}
          
          
        </div>
        <div className="d-flex justify-content-center">
          <button
            // disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {/* {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`} */}
              Submit
            </span>
          </button>
        </div>
      </form>
    </div>
  )
}


Icons.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  // createInput: PropTypes.instanceOf(Function).isRequired,
  createHidden: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  create: PropTypes.instanceOf(Function).isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: (_.get(api, `${c.GET_SETTINGS}.list`) || [])[0] || {},
});

const enhance = _.flowRight([withCmsForm, withRouter, connect(mapStateToProps, actions)]);

export default enhance(Icons);
